import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./App";
import { applyTheme, storedThemeMode } from "./theme";
import "./theme/base.css";

applyTheme(storedThemeMode());

const container = document.getElementById("root");
if (container === null) {
  throw new Error("#root element missing in index.html");
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
